var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-left mb-2 pb-md-1 px-0",staticStyle:{"font-weight":"400","font-size":"0.9em"}},[_c('i',{staticClass:"fas fa-check pr-3"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.instruction)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }